import * as React from 'react'
import Button from 'components/Button'
import styles from './SectionEmptyState.sass'

const DEFAULT_SUBTITLE = "Fill in the client's details on their behalf."

export interface SectionEmptyStateProps {
  title: string
  subtitle?: string
  actionLabel: string
  onAction: () => void
  ['data-test']?: string
}

export default function SectionEmptyState({
  title,
  subtitle = DEFAULT_SUBTITLE,
  actionLabel,
  onAction,
  'data-test': dataTest,
}: SectionEmptyStateProps) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <Button type="text" onClick={onAction} data-test={dataTest}>
        {actionLabel}
      </Button>
    </div>
  )
}
